import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { toSentenceCase } from '../../utils/casing';
import { resolveInternalHref } from '../../utils/internalHref';

// Mirrored in src/staticHero/staticHero.css for landing pages
// (docs/static-hero.md): change both, or the page jumps when React takes over.
const textSx = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: { xs: '0.875rem', sm: '1rem' },
  lineHeight: 1,
  letterSpacing: 0,
  color: '#1E354E',
};

const linkSx = {
  ...textSx,
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
};

const activeSx = {
  ...textSx,
  fontWeight: 700,
};

const separatorSx = {
  ...textSx,
  mx: '4px',
  userSelect: 'none',
};

const BreadcrumbComponent = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <Box
      component="nav"
      aria-label="breadcrumb"
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        rowGap: { xs: '6px', sm: '4px' },
      }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        // Curated labels (the BREADCRUMBS table and the approved breadcrumb
        // sheet) are already in their signed-off casing — sentence-casing them
        // would turn "BMW" into "Bmw" and "1Life Insurance" into "1life
        // insurance". Only labels we derived from a slug or a Contentful
        // heading get normalised here.
        const label = item.exact ? item.label : toSentenceCase(item.label);
        return (
          <React.Fragment key={item.label}>
            {index > 0 && (
              <Typography component="span" sx={separatorSx}>
                &gt;
              </Typography>
            )}
            {isLast ? (
              <Typography component="span" aria-current="page" sx={activeSx}>
                {label}
              </Typography>
            ) : item.href ? (
              <Typography
                component={Link}
                // Crumb hrefs are authored inconsistently, some with a
                // trailing slash and some without. Canonicalising here means
                // the destination never has to redirect on arrival, which
                // would render it twice.
                to={resolveInternalHref(item.href) || item.href}
                sx={linkSx}
              >
                {label}
              </Typography>
            ) : (
              <Typography component="span" sx={textSx}>
                {label}
              </Typography>
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default BreadcrumbComponent;
